import React from "react";

import {
	ProjectBody,
	ProjectFooterNav,
	ProjectHeader,
	ProjectImage,
	UnorderedList,
} from "./ProjectComponents";
import usePageMeta from "../../hooks/usePageMeta";
import { getProject } from "../../data/projects";

import "./project-styles.css";

// Short project pages for selected work that doesn't have a full case study.
// Content describes only what the designs themselves show.
const overviews = {
	smartmoney: {
		subheading:
			"A personal budgeting app for understanding where money goes and staying within monthly limits.",
		intro: "The designs focus on three everyday tasks:",
		highlights: [
			<>
				<b>Analysis:</b> a spending breakdown by category, filterable
				by week, month or all time, with a list of recent expenses.
			</>,
			<>
				<b>Budgeting:</b> monthly limits for categories such as
				groceries, transport and bills, with progress shown for each.
			</>,
			<>
				<b>Quick add:</b> logging an expense in a few taps by picking a
				category and entering an amount.
			</>,
		],
	},
	"windshield-2020": {
		subheading:
			"A donor management dashboard that helps fundraising teams keep track of donors, campaigns and follow-ups.",
		intro: "The dashboard brings a team’s daily work into one view:",
		highlights: [
			<>
				<b>Key numbers:</b> total donors, retention rate and recent
				contacts, with change over time.
			</>,
			<>
				<b>Tasks:</b> assigned, in-progress and overdue work linked to
				each campaign.
			</>,
			<>
				<b>Campaigns needing attention:</b> progress toward each goal
				alongside its deadline.
			</>,
			<>
				<b>Calendar:</b> upcoming meetings, calls and next steps.
			</>,
		],
	},
};

export default function ProjectOverview({ slug }) {
	const project = getProject(slug);
	const overview = overviews[slug];

	usePageMeta(project.name, `${project.name}: ${project.summary}`);

	return (
		<main id="main-content" tabIndex={-1} className="project-page">
			<ProjectHeader
				title={project.name}
				subheading={overview.subheading}
				status={project.status}
				role={project.contribution}
				year={project.date}
				users={project.users}
			/>
			<div className="project-content">
				<ProjectImage src={project.image} alt={project.imageAlt} />

				<ProjectBody title="Overview">
					<p>{overview.intro}</p>
					<UnorderedList items={overview.highlights} />
				</ProjectBody>

				<ProjectFooterNav slug={slug} />
			</div>
		</main>
	);
}
